module.exports = __webpack_public_path__ + "img/destination-1.533f2c61.svg";